export interface ToastEntry {
  id: number;
  message: string;
}

type Listener = (toasts: ToastEntry[]) => void;

let nextId = 1;
let toasts: ToastEntry[] = [];
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((l) => l(toasts));
}

/** Показать тост-уведомление (как в референсе) – сам исчезает через 3с. */
export function showToast(message: string): void {
  const entry = { id: nextId++, message };
  toasts = [...toasts, entry];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== entry.id);
    emit();
  }, 3000);
}

export function subscribeToast(listener: Listener): () => void {
  listeners.add(listener);
  listener(toasts);
  return () => listeners.delete(listener);
}
